export default __webpack_public_path__ + "static/media/car-banner-mobile.38ab6b19.png";